import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { ago } from "@sp-crm/core";
import { SupportEmailLink } from "components/app/support-email-link";
import React from "react";

interface SyncResult {
    status: string;
    syncedAt: string;
}

interface AudienceSyncStatusProps {
    syncResult: SyncResult | null | undefined;
    providerDisplayName: string;
}

export const AudienceSyncStatus: React.FC<AudienceSyncStatusProps> = ({
    syncResult,
    providerDisplayName,
}) => {
    if (!syncResult) {
        return null;
    }

    return (
        <div className="space-y-1">
            <p className="text-sm">Synchronization Status</p>
            <div className="flex items-center space-x-2">
                {syncResult.status === "Success" ? (
                    <>
                        <CheckCircleIcon className="h-4 w-4 text-green-600" />
                        <span className="text-sm text-gray-600">
                            Last synchronized {ago(syncResult.syncedAt)}
                        </span>
                    </>
                ) : (
                    <>
                        <XMarkIcon className="h-4 w-4 text-red-600" />
                        <span className="text-sm text-red-600">
                            Synchronization failed {ago(syncResult.syncedAt)}. Please{" "}
                            <SupportEmailLink
                                label="contact support"
                                subject={`${providerDisplayName} Synchronization Error`}
                            />
                            .
                        </span>
                    </>
                )}
            </div>
        </div>
    );
};
